import script from "./StatoStazione.vue?vue&type=script&setup=true&lang=js"
export * from "./StatoStazione.vue?vue&type=script&setup=true&lang=js"

import "./StatoStazione.vue?vue&type=style&index=0&id=5fff52b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fff52b6"]])

export default __exports__